import { render, staticRenderFns } from "./applicationContent.vue?vue&type=template&id=b056fca2&scoped=true"
import script from "./applicationContent.vue?vue&type=script&lang=js"
export * from "./applicationContent.vue?vue&type=script&lang=js"
import style0 from "./applicationContent.vue?vue&type=style&index=0&id=b056fca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b056fca2",
  null
  
)

export default component.exports